import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import greaterThan from "../assets/greaterthan.svg";
import OtpInput from "./otp-login";

interface otpModalDetails {
  otp: string;
  setOtp: (value: string) => void;
  otpSent: boolean;
  handleOtpValidation: (value: string) => void;
  show: boolean;
  setShow: (value: any) => void;
  onHide: () => any;
  phoneNumber: string;
}

const PhoneOtpModal: React.FC<otpModalDetails> = (props: otpModalDetails) => {
  const updateOtp = (userOtp: any) => {
    console.log(userOtp);
    props.setOtp(userOtp);
    // handleLogin();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      id="otp-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter" className="modal-title">
          OTP Verification
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <>
          <>
            <p>
              We've sent a verification OTP to your mobile number -{" "}
              {props.phoneNumber}
            </p>
          </>
          {/* <input
            className="text-black w-[500px] h-[55px] rounded px-4 mt-12"
            id="otp"
            type="text"
            value={props.otp}
            placeholder="Enter OTP"
            onChange={(e) => props.setOtp(e.target.value)}
          /> */}
          <div className="otp-input-container">
            <OtpInput length={4} updateOtp={updateOtp} />
          </div>
          <button
            className="rounded mt-12 button"
            onClick={() => {
              props.handleOtpValidation("phone");
              props.setShow(false);
            }}
            disabled={props.otp === ""}
          >
            Validate OTP
            <img src={greaterThan} alt="" aria-hidden="true" />
          </button>
        </>
      </Modal.Body>
    </Modal>
  );
};

export default PhoneOtpModal;
